window.addEventListener('DOMContentLoaded', () => {
  console.log('Animation script started');

  const sectionElBestSellers = document.getElementsByClassName('section--featured-product')[0];
  console.log('sectionElBestSellers: ', sectionElBestSellers);
  const sectionElFindUs = document.getElementsByClassName('section--logos')[0];
  const sectionElTestimonials = document.getElementsByClassName('section--testimonials')[0];
  const sectionElHanaSignOff = document.getElementsByClassName('section--home-quote')[0];

  function setStrokeDashoffset (svgLine, svgLength, scrollPercentage) {
    svgLine.style.strokeDashoffset = svgLength * scrollPercentage
  }

  function growVectorLine (sectionElement, svgLine, svgLength, useScroll = false) {

    const scrollPosition = (document.body.scrollTop + document.documentElement.scrollTop)
    // Needs a minus percentage value to scroll in the correct direction
    // As stroke-dashoffset needs to be a minus value
    const offsetVectorStart = window.innerHeight / 2
    const scrollTopDiff = scrollPosition - sectionElement.offsetTop
    const offsetScrollTopDiff = scrollTopDiff + offsetVectorStart
    const scrollPercentage = -(1 - (offsetScrollTopDiff / sectionElement.offsetHeight))

    // Initial stroke offset relative to the page
    if (useScroll) {
      setStrokeDashoffset(svgLine, svgLength, scrollPercentage);
      return;
    }

    // if (offsetScrollTopDiff > -100 && offsetScrollTopDiff < sectionElement.offsetHeight + 100) {
      setStrokeDashoffset(svgLine, svgLength, scrollPercentage)
    // }
  }
  
  function makeVectorLine (sectionElement, color = '#282828') {
    sectionElement.style.position = 'relative';
    const svgWrapperDiv = document.createElement('div');
    svgWrapperDiv.id = 'svg-wrapper';
    svgWrapperDiv.style.position = 'absolute';
    svgWrapperDiv.style.top = 0;
    svgWrapperDiv.style.left = 0;
    svgWrapperDiv.style.right = 0;
    svgWrapperDiv.style.bottom = 0;
    svgWrapperDiv.style.pointerEvents = 'none';
    // Temporarily hide element due to offset animation showing on load
    svgWrapperDiv.style.opacity = 0;
    sectionElement.appendChild(svgWrapperDiv);

    const draw = SVG().addTo(svgWrapperDiv).size(sectionElement.offsetWidth, 0);

    const line = draw.line(0, sectionElement.offsetHeight, 0, 0)
    line.move(sectionElement.offsetWidth / 2, 0)
    line.stroke({ color, width: 3 })

    window.addEventListener('resize', () => {
      draw.size(sectionElement.offsetWidth, sectionElement.offsetHeight);
      line.move(sectionElement.offsetWidth / 2, 0)
    }, true);

    const svgLine = sectionElement.querySelector('svg line')

    // Get length of svg path
    const svgLength = svgLine.getTotalLength();

    // Start position of the drawing - double the length so shows when scrolling back up fast
    svgLine.style.strokeDasharray = svgLength * 2;

    // oOffset the svg upwards before the scrolling starts
    svgLine.style.strokeDashoffset = svgLength;

    // Transition for smoothness (buggy between sections)
    svgLine.style.transition = 'stroke-dashoffset .3s ease-out';

    // Initial stroke offset relative to the page
    growVectorLine(sectionElement, svgLine, svgLength, true);

    // Reveal after lines rendered
    setTimeout(() => {
      svgWrapperDiv.style.transition = 'all .5s ease-out';
      svgWrapperDiv.style.opacity = 1;
    }, 300)

    // Offset the svg dash by the same amount as the percentage scrolled
    window.addEventListener('scroll', function () {

      /*
      * TODO Got to here trying to resize the bottom line with Hana sign off
      */
      console.log(sectionElement.offsetHeight)
      line.size(0, sectionElement.offsetHeight, 0, 0);
      growVectorLine(sectionElement, svgLine, svgLength);
    });


    /*
     * Check for images loaded to resize svg canvas
     */
    const imgs = sectionElement.querySelectorAll('img')

    function loaded(img, completedInitially = 'EVENT') {
      console.log('image complete', completedInitially, img)
      console.log('draw before: ', draw);
      draw.size(sectionElement.offsetWidth, sectionElement.offsetHeight);

      /*
      * TODO Got to here trying to resize the bottom line with Hana sign off
      */
      line.size(0, sectionElement.offsetHeight, 0, 0);

      console.log('draw after: ', draw);
    }

    imgs.forEach(img => {
      if (img) {
        if (img.complete) {
          loaded(img, 'INITIAL')
        } else {
          img.addEventListener('load', loaded(img))
          img.addEventListener('error', function() {
              console.error('img did not load: ', img)
          })
        }
      } else {
        console.log('no image in: ' + svgWrapperDiv)
      }
    });
  }

  // Commented for now
  // makeVectorLine(sectionElBestSellers);
  // makeVectorLine(sectionElFindUs);
  // makeVectorLine(sectionElTestimonials, 'white');
  // makeVectorLine(sectionElHanaSignOff);
});